export const moeda = (v: string | number | null | undefined) => {
  if (v === null || v === undefined || v === "") return "—";
  const n = typeof v === "number" ? v : Number(v);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

export const data = (v: string | null | undefined) =>
  v ? new Date(v).toLocaleDateString("pt-BR") : "—";

export const dataHora = (v: string | null | undefined) =>
  v
    ? new Date(v).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "—";

/** Data e hora enxutas para as listas: 12/09/26 11:30 */
export const dataHoraCurta = (v: string | null | undefined) => {
  if (!v) return "—";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return "—";
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${String(d.getFullYear()).slice(2)} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

/**
 * Encurta o nome do curso nas listas. "Ensino" e "Período" não distinguem
 * nada entre as opções — só ocupam espaço e forçam a quebra de linha.
 * O nome completo continua no title da célula e na ficha impressa.
 */
export const cursoCurto = (nome: string | null | undefined) => {
  if (!nome) return "—";
  return nome
    .replace(/^Ensino\s+/i, "")
    .replace(/^Educação\s+/i, "Ed. ")
    .replace(/^Período\s+/i, "");
};

export const soDigitos = (v: string) => v.replace(/\D/g, "");

// Telefone saiu daqui: formatar e validar passaram a depender do país, e a
// regra inteira mora em `./paises` — `mascaraPorPais`, `telefoneExibicao`,
// `telefoneCompleto`, `telefoneValido`.

/**
 * Data pura vinda da API ("2017-05-03T00:00:00.000Z") → "03/05/2017".
 * Devolve "" quando não há data — quem exibe decide se vira travessão.
 */
export const dataNasc = (v: string | null | undefined) => {
  if (!v) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : "";
};

/**
 * Máscara de data enquanto se digita: 02/08/2015.
 *
 * Existe porque o `<input type="date">` do navegador não deixa digitar o ano
 * corrido — o campo é dividido em três caixinhas e o ano aceita coisas como
 * "0015". Aqui é campo de texto comum: digita oito números e pronto.
 */
export function mascaraData(valor: string): string {
  const d = soDigitos(valor).slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
}

/**
 * "03/05/2017" → "2017-05-03". Devolve "" enquanto a data não estiver
 * completa **e** existir de verdade — 31/02 e 30/02 caem fora aqui.
 */
export function dataBrParaIso(valor: string): string {
  const d = soDigitos(valor);
  if (d.length !== 8) return "";
  const dia = Number(d.slice(0, 2));
  const mes = Number(d.slice(2, 4));
  const ano = Number(d.slice(4));
  if (ano < 1900 || mes < 1 || mes > 12 || dia < 1) return "";
  const dt = new Date(Date.UTC(ano, mes - 1, dia));
  if (dt.getUTCMonth() !== mes - 1 || dt.getUTCDate() !== dia) return "";
  return `${d.slice(4)}-${d.slice(2, 4)}-${d.slice(0, 2)}`;
}
